// web.selector.ts
import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { WebState } from './web.state';

export const SELECT_WEB_STATE = createFeatureSelector<WebState>('web');

// car detail
export const SELECT_CAR_DETAIL = createSelector(SELECT_WEB_STATE, (state) => state.carDetail);

// location
export const SELECT_LOCATION_DETAIL = createSelector(
  SELECT_WEB_STATE,
  (state) => state.locationDetail
);

// autocomplete
export const SELECT_LOCATION_AUTO_COMPLETE_LIST = createSelector(
  SELECT_WEB_STATE,
  (state) => state.locationAutoCompleteList
);

export const SELECT_IS_SEARCHING_LOCATION = createSelector(
  SELECT_WEB_STATE,
  (state) => state.isSearchingLocation
);

// filters
export const SELECT_FILTERS = createSelector(SELECT_WEB_STATE, (state) => state.filters);

export const SELECT_FILTER_NAMES = createSelector(SELECT_FILTERS, (filters) => filters.name);

export const SELECT_FILTER_MAKES = createSelector(SELECT_FILTERS, (filters) => filters.make);
export const SELECT_FILTER_TRANSMISSION = createSelector(
  SELECT_FILTERS,
  (filters) => filters.transmission
);

export const SELECT_FILTER_SEATS = createSelector(SELECT_FILTERS, (filters) => filters.seats);

export const SELECT_FILTER_TYPES = createSelector(SELECT_FILTERS, (filters) => filters.type);

// extras
export const SELECT_EXTRAS = createSelector(SELECT_WEB_STATE, (state) => state.extras);

export const SELECT_EXTRAS_LOADING = createSelector(
  SELECT_WEB_STATE,
  (state) => state.extrasLoading
);

export const SELECT_EXTRAS_ERROR = createSelector(SELECT_WEB_STATE, (state) => state.extrasError);

export const SELECT_ADDITIONAL_DRIVER_PRICE = createSelector(SELECT_EXTRAS, (extras) => {
  const DRIVER = extras.find((item) => item.type === 'Car Delivery');
  return DRIVER ? DRIVER : null;
});

export const SELECT_UNLIMITED_KM_ALLOWANCE_PRICE = createSelector(SELECT_EXTRAS, (extras) => {
  const KM = extras.find((item) => item.type === 'Unlimited KM Allowance Price');
  return KM ? KM : null;
});
